import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import ctaBackground from "@/assets/carbonwize-contact-bg.png";

const DecarbonwizeCTASection = () => {
  const { t, language } = useLanguage();
  const isThai = language === "th";

  const benefits = [
    t("cta.benefit1"),
    t("cta.benefit2"),
    t("cta.benefit3")
  ];

  return (
    <section id="pricing" className="py-24 lg:py-32 bg-background relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#166a9c]/10 to-transparent opacity-30" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="relative px-6 py-12 sm:p-12 lg:p-16 overflow-hidden min-h-[620px] sm:min-h-0 rounded-3xl bg-[#3a3631]">
            {/* Background gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#166a9c]/20 to-transparent rounded-3xl" />

            <div className="relative text-left">
              <h2 className={`font-bold text-white mb-6 ${isThai ? "text-2xl sm:text-3xl lg:text-4xl" : "text-3xl sm:text-4xl lg:text-5xl"}`}>
                {t("cta.title1")}
                <span className="block mt-2 text-[#166a9c]">{t("cta.title2")}</span>
              </h2>

              <p className={`text-white/80 max-w-2xl mb-8 ${isThai ? "text-base sm:text-lg" : "text-lg sm:text-xl"}`}>
                {t("cta.descriptionLine1")}
                <br />
                {t("cta.descriptionLine2")}
              </p>

              {/* Benefits */}
              <div className="flex flex-wrap justify-start gap-4 lg:gap-6 mb-10">
                {benefits.map((benefit) => (
                  <div key={benefit} className="flex items-center gap-2 text-white/90">
                    <CheckCircle className="w-5 h-5 text-[#166a9c]" />
                    <span className="text-sm font-medium">{benefit}</span>
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-start">
                <Button size="xl" className="w-full sm:w-auto bg-[#166a9c] hover:bg-[#166a9c]/90 text-white shadow-lg hover:shadow-xl" asChild>
                  <Link to="/contact-us">
                    {t("cta.contactUs")}
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </Button>
                <Button size="xl" variant="outline" className="w-full sm:w-auto border-2 border-white/30 bg-transparent text-white hover:bg-white/10 hover:border-white/50" asChild>
                  <Link to="/become-partner">
                    {t("cta.partnerWithUs")}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DecarbonwizeCTASection;
